<template>
  <div>
    <v-btn
      color="pink darken-2"
      class="white--text ml-0"
      @click="mediaDialog = true"
    >
      {{ $vuetify.t('$vuetify.preWorkAnalysis.uploadTakePhoto') }}
      <v-icon right dark>photo_camera</v-icon>
    </v-btn>
    <v-layout row>
      <span v-if="savedMedia && savedMedia.length > 0"
        >{{ savedMedia.length }}
        {{ $vuetify.t('$vuetify.preWorkAnalysis.photosSelected') }}</span
      >
      <span v-else class="red--text">{{
        $vuetify.t('$vuetify.preWorkAnalysis.atLeastOnePhoto')
      }}</span>
    </v-layout>

    <v-dialog v-model="mediaDialog" fullscreen persistent>
      <v-card>
        <v-card-title
          class="headline indigo darken-4 white--text"
          primary-title
        >
          {{ $vuetify.t('$vuetify.calls.media').toUpperCase() }}
        </v-card-title>
        <v-card-text>
          <v-toolbar color="white" flat>
            <v-tooltip bottom>
              <v-btn @click="saveMedia()" icon light slot="activator">
                <v-icon color="grey darken-2">arrow_back</v-icon>
              </v-btn>

              <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
            </v-tooltip>

            <v-toolbar-title>{{
              $vuetify.t('$vuetify.preWorkAnalysis.uploadTakePhoto')
            }}</v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>
          <v-layout row wrap mt-3 mb-3>
            <v-flex xs12 md6>
              <camera-dialog :stage="this.stage"></camera-dialog>
            </v-flex>
            <v-flex md6 xs12>
              <v-card class="uploadButton btn-file" color="blue darken-2">
                <v-card-text class="white--text text-xs-center">
                  <v-icon color="white" x-large>attach_file</v-icon>
                  <div class="headline text-xs-center">Upload Photos</div>
                  <input
                    @change="handleFiles"
                    accept="image/*"
                    multiple
                    ref="photoFiles"
                    type="file"
                  />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout mb-3 mt-1 row wrap v-if="uploadProgress">
            <v-flex md6 xs12>
              <v-progress-linear
                v-model="uploadProgress"
                height="30"
                color="orange"
              >
                {{ uploadProgress }}%
              </v-progress-linear>
            </v-flex>
          </v-layout>
        </v-card-text>
        <pre-work-analysis-media-list
          ref="mediaList"
          :mediaItems="getMediaList(callDetail)"
        />
        <v-card-actions>
          <v-layout justify-center row>
            <v-btn @click="saveMedia()" color="success">{{
              $vuetify.t('$vuetify.app.save')
            }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import CameraDialog from '@/components/media/CameraDialog.vue'
import PreWorkAnalysisMediaList from '../arrival/PreWorkAnalysisMediaList.vue'
import helpers from '@/utils/helpers'

export default {
  props: ['stage'],
  components: {
    PreWorkAnalysisMediaList,
    CameraDialog
  },
  data() {
    return {
      mediaDialog: false,
      cameraDialog: false,
      savedMedia: null
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    },
    cameraDialog: function(newVal, oldVal) {
      if (newVal == true) {
        this.getStream()
      } else {
        if (this.mediaStream) {
          const tracks = this.mediaStream.getTracks()
          tracks.map(track => track.stop())
        }
      }
    }
  },
  computed: {
    ...mapState({
      uploadProgress: state => state.calls.uploadProgress
    }),
    ...mapGetters({
      activeCallId: 'calls/activeCallId',
      callDetail: 'calls/getActiveCall'
    }),
    selectedMedia() {
      return this.$refs.mediaList.selectedMedia
        ? this.$refs.mediaList.selectedMedia
        : null
    }
  },
  created() {
    window.addEventListener('offline', () => {
      console.log('here offline')
      this.updateProgress(undefined)
      this.setNetworkStatus('offline')
      this.cancelRequest()
    })
    window.addEventListener('online', () => {
      this.setNetworkStatus(undefined)
    })
  },
  mounted() {},
  methods: {
    ...mapActions({
      addMedia: 'calls/addMedia',
      updateProgress: 'calls/updateProgress',
      setNetworkStatus: 'calls/setNetworkStatus',
      cancelRequest: 'calls/cancelRequest'
    }),
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),
    getMediaList(call) {
      return call.media || []
    },
    back() {
      this.dialog = false
      this.$emit('back')
    },
    now() {
      return moment().format('DD/MM/YYYY HH:mm')
    },
    saveMedia() {
      this.mediaDialog = false
      this.savedMedia = this.selectedMedia
    },
    handleFiles() {
      const callId = this.activeCallId
      this.files = this.$refs.photoFiles.files
      const _this = this
      Array.from(this.files).forEach(file => {
        const maxWidth = process.env.VUE_APP_IMG_MAX_WIDTH
        const maxHeight = process.env.VUE_APP_IMG_MAX_HEIGHT
        helpers.resizeImage(file, maxWidth, maxHeight).then(res => {
          const media = {}
          media.src = res
          media.name = file.name
          media.type = 'image'
          media.model_id = callId
          media.collection_name = 'media'
          media.stage = _this.stage
          _this.updateProgress(10)
          _this
            .addMedia({ id: callId, media: media })
            .then(() => {})
            .catch(e => {
              console.log(e, 'error')
            })
          // _this.$refs.mediaList.selectedMedia.push(media)
        })
      })
    }
  },
  destroyed: function() {
    window.removeEventListener('offline', this.updateProgress)
    window.removeEventListener('online', this.updateProgress)
  }
}
</script>

<style scoped>
.btn-file {
  position: relative;
  overflow: hidden;
}

.btn-file input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  opacity: 0;
  outline: none;
  background: #fff;
  cursor: inherit;
  display: block;
}
</style>
